import React from "react";
import { useRoutes } from "react-router-dom";

import { HomeLayout } from "../layouts";
import { Home } from "../pages/Home";
import { AutoPee, Install, Xtool } from "../pages/Install";
import { CheckSim } from "../pages/CheckSim";
import { CheckSimLayout } from "../layouts/checksim";
import { CheckMVD } from "../pages/CheckMVD";
import CheckMVDCookie from "../pages/CheckMVD/CheckMVDCookie";
import { Voucher50k } from "../pages/testPage";
import ConvertSPC from "../pages/ConvertSPC";
import ReadHotmail from "../pages/ReadHotmail";

const Routers = () => {
  const routing = useRoutes([
    // {
    //   path: "/",
    //   element: <HomeLayout />,
    //   children: [{ path: "", element: <Home /> }],
    // },
    {
      path: "/checkMVD",
      element: <CheckMVD />,
    },
    {
      path: "/checkMVDCookie",
      element: <CheckMVDCookie />,
    },
    {
      path: "/readHotmail",
      element: <ReadHotmail />,
    },
    // {
    //   path: "/checkSim",
    //   element: <CheckSim />,
    // },
    { path: "/voucher50kpee", element: <Voucher50k /> },
    { path: "/convertSPC", element: <ConvertSPC /> },
    // {
    //   path: "/install",
    //   element: <HomeLayout />,
    //   children: [
    //     {
    //       path: "",
    //       element: <Install />,
    //       children: [
    //         { path: "xtool", element: <Xtool /> },
    //         { path: "autopee", element: <AutoPee /> },
    //       ],
    //     },
    //   ],
    // },
    {
      path: "/check-sim-shopee",
      element: <CheckSimLayout />,
      children: [
        {
          path: "",
          element: <CheckSim />,
        },
      ],
    },
  ]);
  return routing;
};

export default Routers;
